import React from "react";
import "./OlaplexLandingWork.css"

const OlaplexLandingWorkStatic = () => {
  return (
    <div className="olaplexLandingWorkCard" id="olaplexWorkCardStatic">
      <div className="olaplexWorkCardStaticContent">
        <h3>Styling Inspiration</h3>
        <div className="olaplexLandingWorkCardUnderline"></div>
        <p>CURRENT TRENDS, STYLING TIPS AND MUCH MORE</p>
      </div>
    </div>
  );
};

export default OlaplexLandingWorkStatic;
